module.exports = __webpack_public_path__ + "files/513899b98e719e39d32ad89f3bdf1742.png";